import type { OperatorConfig } from '../types';

/**
 * EOS Nation Environment Configuration
 * Production environment (deweb-519a7 / roundtable.io)
 */
export const eosnationConfig: OperatorConfig = {
    operatorName: 'eosnation',
    domainDisplayName: 'EOS Nation',
    operatorSalt: 'AP5A559C2AV3LSKDF1F5R152LKAL',
    domainName: '',
    rpcBaseUrl: 'https://eos.api.eosnation.io',
    contractName: 'deweb.eosn',
    registryContractName: 'dwebregistry',
    fiatInProviders: ['moonpay', 'EOS-Transfer'],
    backedToken: 'BBS',
    bbsTokenETH: '', // Not used in production
    stakingContractETH: '', // Not used in production
    selectedNetworkName: 'mainnet',
    contractDeploymentBlock: 0,
    stakingTokenPageRedirect: 'RTBHOME',
    moonpayWidgetBaseUrl: 'https://buy.moonpay.io',
    moonpayApiKey: 'pk_live_1aaeDBMsbzhFjyKAKvZlQQzARZOa5g0',
    transakApiKey: '1dbef101-1976-4e62-8e93-094743bc6941',
    transakWidgetBaseUrl: 'https://global.transak.com',
    appCheckRecaptchaKey: '6LfgKbodAAAAAPykgcQBdBmipmI5Xuy-C_foB6u4',
    frontendFunctionsBaseUrl: 'https://mainwebpagev2-vm3pvcnqua-uc.a.run.app/api',
    functionsBaseUrl: 'https://us-central1-deweb-519a7.cloudfunctions.net',
    cloudRunBaseUrl: 'https://bbs-cloudrun-415743429355.us-central1.run.app/bbs-api',
    firebaseConfig: {
        apiKey: 'AIzaSyCR_ilM4E4MlKvqNDpNmaCIV8cnPDRsigU',
        authDomain: 'roundtable.io',
        databaseURL: 'https://deweb-519a7.firebaseio.com',
        projectId: 'deweb-519a7',
        storageBucket: 'deweb-519a7.appspot.com',
        messagingSenderId: '415743429355',
        appId: '1:415743429355:web:9f697613260920656d8cae',
    },
    upvote: {
        contractName: 'discuss.eosn',
    },
    mobileApp: {
        apn: 'io.deweb.messageboard.bobby',
        dynamicLink: 'https://bbsnetwork.page.link',
        announcementUrl: 'https://roundtable.rtb.io/',
        isi: '6450423049',
        ibi: 'io.deweb.messageboard.bobby',
    },
    googleProviderClientId: '415743429355-joa7lj4p98gqscu536fhion2e8cmlv5s.apps.googleusercontent.com',
    cdn: {
        storageBaseUrl: 'https://deweb-519a7.b-cdn.net',
    },
};
